import PropTypes from 'prop-types';
import styled from 'styled-components';

import styledContainerMixin from '../../themes/components/StyledContainer';

/**
 * Example usage:
 *  <StyledContainer
 *      backgroundColor="grey"
 *      backgroundHoverColor="primary"
 *      borderBottom
 *      borderColor="dark"
 *      borderHoverColor="primary"
 *      borderWidth="medium"
 *      borderStyle="dashed"
 *  >
 *      <Text>This is some text</Text>
 *  </StyledContainer>
 */
const StyledContainer = styled.div`
  ${styledContainerMixin}
`;

const BACKGROUND_COLOR_OPTIONS = [
  'white',
  'grey',
  'lightGrey',
  'lighterGrey',
  'lightestGrey',
  'dark',
  'primary',
  'alert',
  'zrmBackground',
];

const BORDER_COLOR_OPTIONS = ['default', 'dark', 'primary'];

const BORDER_STYLE_OPTIONS = ['solid', 'dashed', 'dotted'];

const BORDER_WIDTH_OPTIONS = ['thin', 'medium', 'thick'];

StyledContainer.propTypes = {
  /** Background Color */
  backgroundColor: PropTypes.oneOf(BACKGROUND_COLOR_OPTIONS),
  backgroundHoverColor: PropTypes.oneOf(BACKGROUND_COLOR_OPTIONS),
  /** Borders */
  borderColor: PropTypes.oneOf(BORDER_COLOR_OPTIONS),
  borderHoverColor: PropTypes.oneOf(BORDER_COLOR_OPTIONS),
  borderWidth: PropTypes.oneOf(BORDER_WIDTH_OPTIONS),
  borderStyle: PropTypes.oneOf(BORDER_STYLE_OPTIONS),
  borderTop: PropTypes.bool,
  borderRight: PropTypes.bool,
  borderBottom: PropTypes.bool,
  borderLeft: PropTypes.bool,
  borderFull: PropTypes.bool,
  borderRounded: PropTypes.bool,
  /** Rest */
  children: PropTypes.node.isRequired,
};

StyledContainer.defaultProps = {
  /** Borders */
  borderColor: 'default',
  borderWidth: 'thin',
  borderStyle: 'solid',
  borderTop: false,
  borderRight: false,
  borderBottom: false,
  borderLeft: false,
  borderFull: false,
  borderRounded: false,
};

export default StyledContainer;
